import { render, staticRenderFns } from "./NavbarHorizontal2.vue?vue&type=template&id=dd40cb2a&scoped=true&"
import script from "./NavbarHorizontal2.vue?vue&type=script&lang=js&"
export * from "./NavbarHorizontal2.vue?vue&type=script&lang=js&"
import style0 from "./NavbarHorizontal2.vue?vue&type=style&index=0&id=dd40cb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd40cb2a",
  null
  
)

export default component.exports